"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var color_1 = __importDefault(require("color"));
var Colors = __importStar(require("@brightlayer-ui/colors"));
var getHeight = function (props) { return (props.dense ? "3.25rem" : "4.5rem"); };
var getIconColor = function (props, theme) {
    var avatar = props.avatar, iconColor = props.iconColor, statusColor = props.statusColor;
    if (iconColor)
        return iconColor;
    if (avatar) {
        return statusColor ? (color_1.default(statusColor).isDark() ? Colors.white[50] : Colors.black[500]) : Colors.white[50]; // default avatar is dark gray -> white text
    }
    return statusColor ? statusColor : theme.palette.text.secondary;
};
var isWrapEnabled = function (props) { return props.wrapSubtitle || props.wrapTitle || props.wrapInfo; };
var getIconAlignment = function (props) {
    switch (props.iconAlign) {
        case 'left':
            return 'flex-start';
        case 'right':
            return 'flex-end';
        case 'center':
        default:
            return 'center';
    }
};
/* eslint-disable @typescript-eslint/explicit-function-return-type */
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            cursor: function (props) { return (props.onClick ? 'pointer' : 'inherit'); },
            backgroundColor: function (props) { return props.backgroundColor || 'inherit'; },
            minHeight: function (props) { return (isWrapEnabled(props) ? getHeight(props) : 'initial'); },
            height: function (props) { return (!isWrapEnabled(props) ? getHeight(props) : 'auto'); },
            '&:hover': {
                backgroundColor: function (props) {
                    return props.onClick
                        ? props.backgroundColor &&
                            props.backgroundColor !== 'inherit' &&
                            props.backgroundColor !== 'transparent'
                            ? color_1.default(props.backgroundColor).darken(0.08).string()
                            : theme.palette.action.hover
                        : undefined;
                },
            },
            '&:focus': {
                outline: 'none',
            },
        },
        avatar: {
            backgroundColor: function (props) { return props.statusColor || Colors.black[500]; },
            color: function (props) { return getIconColor(props, theme); },
            width: "2.5rem",
            height: "2.5rem",
            padding: ".5rem",
            marginRight: theme.spacing(2),
        },
        invisible: {
            opacity: 0,
        },
        divider: {
            position: 'absolute',
            bottom: 0,
            right: function (props) { return (theme.direction === 'rtl' ? (props.divider === 'full' ? 0 : "4.5rem") : 0); },
            left: function (props) { return (theme.direction === 'ltr' ? (props.divider === 'full' ? 0 : "4.5rem") : 0); },
            zIndex: 0,
        },
        listItemText: {
            // we have to specify both here because the auto-swap from JSS isn't smart enough to do it when we use a function
            marginLeft: function (props) { return (props.leftComponent ? (theme.direction === 'rtl' ? 0 : theme.spacing(2)) : 0); },
            marginRight: function (props) { return (props.leftComponent ? (theme.direction === 'rtl' ? theme.spacing(2) : 0) : 0); },
        },
        icon: {
            color: function (props) { return getIconColor(props, theme); },
            justifyContent: function (props) { return getIconAlignment(props); },
            backgroundColor: 'transparent',
            overflow: 'visible',
            width: "2.5rem",
            height: "2.5rem",
            marginRight: theme.spacing(2),
        },
        info: {
            fontWeight: 400,
            lineHeight: 1.3,
            color: function (props) {
                return props.fontColor || (theme.palette.type === 'dark' ? theme.palette.text.secondary : 'inherit');
            },
        },
        rightComponent: {
            flex: '0 0 auto',
            marginLeft: theme.spacing(2),
            display: 'flex',
            alignItems: 'center',
        },
        separator: {
            display: 'inline-block',
            lineHeight: 1.3,
            color: 'inherit',
            margin: "0 " + theme.spacing(0.5) + "px",
        },
        statusStripe: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: 6,
            zIndex: 100,
            backgroundColor: function (props) { return props.statusColor; },
        },
        subtitle: {
            fontWeight: 400,
            lineHeight: 1.3,
            color: function (props) {
                return props.fontColor || (theme.palette.type === 'dark' ? theme.palette.text.secondary : 'inherit');
            },
        },
        title: {
            fontWeight: 600,
            lineHeight: 1.25,
            display: 'block',
            color: function (props) { return props.fontColor || 'inherit'; },
        },
        flipIcon: theme.direction === 'rtl'
            ? {
                transform: 'scaleX(-1)',
            }
            : {},
    });
});
